import { Component } from "@angular/core";

@Component({
  selector: 'pg-parceiros',
  templateUrl: './parceiros.page.html',
  styleUrls: ['./parceiros.page.scss']
})
export class ParceirosPage {

  constructor(){
  }
}